import antdIT from 'antd/locale/it_IT';
import saMessages from "../locales/it_IT.json";

const itLang = {
  messages: {
    ...saMessages
  },
  antd: antdIT,
  locale: 'it-IT',
};
export default itLang;
